import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Wo1110GetResultModel, Wo1110GetResultSchema } from './get.schema'

export async function fetchWo1110(id: number): Promise<Wo1110GetResultModel> {
  const response = await axios.get<Wo1110GetResultModel>(
    `/api/production/wo1110/${id}`
  )
  return Wo1110GetResultSchema.parse(response.data)
}

export const getWo1110ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['wo1110', id],
    queryFn: () => fetchWo1110(id),
  })
